import React from 'react';
import styled from 'styled-components';
import { Box, Typography } from '@material-ui/core';

export const StyledCenterView = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
  .content {
    padding: 20px;
    text-align: center;
    .MuiSvgIcon-root {
      font-size: 180px;
    }
  }
  &::before {
    content: '';
    flex: 1 1 45%;
  }
  &::after {
    content: '';
    flex: 1 1 55%;
  }
`;

const StyledContent = styled.div`
  padding: 20px;
  text-align: center;
  .MuiSvgIcon-root {
    font-size: 180px;
  }
`;

export interface ErrorViewProps {
  title: string | JSX.Element;
  description: string | JSX.Element;
  icon?: JSX.Element;
  className?: string;
}

const ErrorView: React.FC<ErrorViewProps> = (props: ErrorViewProps) => {
  const { className, ...contentProps } = props;
  return (
    <StyledCenterView className={className}>
      <ErrorContent {...contentProps} />
    </StyledCenterView>
  );
};

export const ErrorContent: React.FC<ErrorViewProps> = (
  props: ErrorViewProps
) => {
  const { title, description, icon, className = '' } = props;
  return (
    <StyledContent className={`content ${className}`}>
      {icon && <Box mb={1}>{icon}</Box>}
      <Box mb={1}>
        {typeof title !== 'string' ? (
          title
        ) : (
          <Typography variant='h4'>{title}</Typography>
        )}
      </Box>
      <Box mb={4}>
        {typeof description !== 'string' ? (
          description
        ) : (
          <Typography variant='body1' color='textSecondary'>
            {description}
          </Typography>
        )}
      </Box>
    </StyledContent>
  );
};

export default ErrorView;
